module.exports = __webpack_public_path__ + "img/developer-consent.svg";